import type { ReactNode } from 'react';
import type { MetricKey, Visualization } from '@contracts';
import { METRIC_CATALOG } from '@contracts';

/** Clase compartida de los `<select>` del wizard. */
export const SELECT = 'w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-red-600';

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="mb-4">
      <label className="mb-1.5 block text-sm font-semibold text-slate-700">{label}</label>
      {children}
    </div>
  );
}

export function Section({ icon, title, children }: { icon: ReactNode; title: string; children: ReactNode }) {
  return (
    <div className="pb-2">
      <div className="mb-3 flex items-center gap-2">
        {icon}
        <h3 className="text-sm font-bold text-slate-800">{title}</h3>
      </div>
      {children}
    </div>
  );
}

/** Vista previa ilustrativa de la visualización elegida (paso "Visual"). */
export function Preview({ metric, visualization }: { metric: MetricKey | null; visualization: Visualization }) {
  const label = metric ? METRIC_CATALOG.find((m) => m.key === metric)?.label : 'Datos';
  if (visualization === 'kpi') {
    return (
      <div className="grid h-28 place-items-center rounded-xl bg-gradient-to-br from-red-600 to-rose-800 text-white">
        <div className="text-center">
          <p className="text-[10px] font-bold uppercase tracking-wider text-white/80">{label}</p>
          <p className="text-3xl font-black">$1,234,567</p>
        </div>
      </div>
    );
  }
  if (visualization === 'table') {
    return (
      <div className="rounded-xl border border-slate-200 p-3 text-xs text-slate-500">
        <div className="flex justify-between border-b py-1 font-semibold"><span>Concepto</span><span>Valor</span></div>
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex justify-between py-1"><span>Ejemplo {i}</span><span>${(i * 1234).toLocaleString()}</span></div>
        ))}
      </div>
    );
  }
  const heights = [70, 90, 55, 80, 45];
  return (
    <div className="flex h-28 items-end justify-around gap-2 rounded-xl border border-slate-200 bg-slate-50 p-3">
      {heights.map((h, i) => (
        <div key={i} className="w-full rounded-t bg-gradient-to-t from-red-700 to-red-400" style={{ height: `${h}%` }} />
      ))}
    </div>
  );
}
